module.exports = __webpack_public_path__ + "static/img/community05.abf9925.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/community05.jpg
// module id = ceja
// module chunks = 0